import {ReactComponent as Home} from '@images/home.svg';
import {ReactComponent as Analytics} from '@images/analytics.svg';
import {ReactComponent as Gift} from '@images/gift.svg';
import {ReactComponent as Inventory} from '@images/inventory.svg';
import {ReactComponent as Marketing} from '@images/marketing.svg';
import {ReactComponent as Setup} from '@images/setup.svg';
import {ReactComponent as PointsSetup} from '@images/pointsSetup.svg';
import {ReactComponent as User} from '@images/user.svg';

export const getStoreMenus = t => [
  {
    title: t('sidebar.menuItems.home'),
    breadcrumb: `${t('sidebar.breadcrumbs.dashboard')} /`,
    path: '/',
    icon: ({isActive}) => (
      <Home
        className={`fill-current ${
          isActive ? 'text-red' : 'text-menu group-hover:text-red'
        }`}
      />
    ),
  },
  {
    title: t('sidebar.menuItems.storeSetup'),
    breadcrumb: `${t('sidebar.breadcrumbs.dashboard')} / ${t(
      'sidebar.breadcrumbs.loyaltySetup',
    )}`,
    path: '/store-setup',
    icon: ({isActive}) => (
      <Setup
        className={`fill-current ${
          isActive ? 'text-red' : 'text-menu group-hover:text-red'
        }`}
      />
    ),
  },
  {
    title: t('sidebar.menuItems.pointsSetup'),
    breadcrumb: `${t('sidebar.breadcrumbs.dashboard')} / ${t(
      'sidebar.breadcrumbs.loyaltyProgram',
    )}`,
    path: '/points-setup',
    icon: ({isActive}) => (
      <PointsSetup
        className={`fill-current ${
          isActive ? 'text-red' : 'text-menu group-hover:text-red'
        }`}
      />
    ),
  },
  {
    title: t('sidebar.menuItems.approveRedeems'),
    breadcrumb: `${t('sidebar.breadcrumbs.dashboard')} / ${t(
      'sidebar.breadcrumbs.approveRewards',
    )}`,
    path: '/approve-redeems',
    icon: ({isActive}) => (
      <Gift
        className={`fill-current ${
          isActive ? 'text-red' : 'text-menu group-hover:text-red'
        }`}
        height={19}
      />
    ),
  },
  {
    title: t('sidebar.menuItems.shopUsers'),
    breadcrumb: `${t('sidebar.breadcrumbs.dashboard')} / ${t(
      'sidebar.breadcrumbs.users',
    )}`,
    path: `/shop-users/`,
    icon: ({isActive}) => (
      <User
        className={`fill-current ${
          isActive ? 'text-red' : 'text-menu group-hover:text-red'
        }`}
      />
    ),
  },
  {
    title: t('sidebar.menuItems.inventory'),
    breadcrumb: `${t('sidebar.breadcrumbs.dashboard')} / ${t(
      'sidebar.breadcrumbs.inventory',
    )}`,
    path: '/products',
    icon: ({isActive}) => (
      <Inventory
        className={`fill-current ${
          isActive ? 'text-red' : 'text-menu group-hover:text-red'
        }`}
      />
    ),
  },
];
// export const analyticsMenus = [
//   {
//     title: 'Marketing',
//     breadcrumb: 'Dashboard / Marketing',
//     path: '/marketing',
//     icon: ({isActive}) => (
//       <Marketing
//         className={`fill-current ${isActive ? 'text-red' : 'text-menu'}`}
//       />
//     ),
//   },
//   {
//     title: 'Analytics',
//     breadcrumb: 'Dashboard / Analytics',
//     path: '/analytics',
//     icon: ({isActive}) => (
//       <Analytics
//         className={`fill-current ${isActive ? 'text-red' : 'text-menu'}`}
//       />
//     ),
//   },
// ];
